import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';


import {
  existingUserEvent,
  existingUserEventFS,
  existingUserEventGA,
  afterAuthRoute,
  reestablishSession,
  loading }
  from '../../../actions/sessions';
  
import GA from '../../../lib/ga';
import Heap from '../../../lib/heap';
import FullStory from '../../../lib/full_story';
import Loading from '../../shared/Loading';
import UserTokenVerification from '../../shared/UserTokenVerification';
import { asyncActions } from '../../../actions/general';
import { setToken, tokenIsExpired } from '../../../actions/authentication';

const heap = new Heap('ExistingUser');
const fs = new FullStory('ExistingUser');
const ga = new GA();

export default function ExistingUserToken({ match }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const isLoading = useSelector(state => state.sessions.get('loading'));
  const token = useSelector(state => state.authentication.get('token'));

  const pathParts = match?.path.split('/');

  if (!match || (!match.params.type && !match.params.contact)) {
    return (
      <div role="error" className="notification is-danger">
        Something went wrong, please <Link to="/init/existing_user">go back</Link> and try again.
      </div>
    );
  }

  const afterAuthCallback = (twofactor, verifiedUser, verifiedToken) => {
    return dispatch(
      asyncActions(
        !twofactor && reestablishSession(verifiedUser, verifiedToken),
        pathParts[1] === 'init' && existingUserEvent(heap, verifiedUser),
        pathParts[1] === 'init' && existingUserEventFS(fs, verifiedUser),
        pathParts[1] === 'init' && existingUserEventGA(ga, verifiedUser),
      ),
    )
      .then(() => dispatch(afterAuthRoute(history, twofactor)))
      .finally(() => dispatch(loading(false)));
  };

  const onLockout = () => {
    history.push('/init/user_lockout');
  }

  const onNotBorrower = () => {
    history.push('/init/user_is_not_borrower');
  }

  return (
    <div id="content">
      <div className="columns is-centered">
        <div className="column has-text-centered">
          <p className="title is-spaced has-text-centered">Please enter the 6-digit code</p>
          {match.params.type === 'phone' && <p className="has-text-centered">We'll text a 6-digit code to your phone if it matches the number on your account.</p>}
          {match.params.type === 'email' && <p className="has-text-centered">We'll email a 6-digit code to you if it matches the email address on your account.</p>}
        </div>
      </div>
      <div className='is-flex is-justify-content-center'>
        <UserTokenVerification
          onAfterAuth={afterAuthCallback}
          expired={tokenIsExpired(token)}
          match={match}
          onLoading={loading}
          isLoading={isLoading}
          onLockout={onLockout}
          onNotBorrower={onNotBorrower}
          onSaveToken={setToken}
        >
          <Loading active={true} />
        </UserTokenVerification>
      </div>
    </div>
  )
}
